import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { useTranslation } from "react-i18next";

import "./styles.css";

interface ICookiePolicyProps {}

const CookiePolicy: React.FC<ICookiePolicyProps> = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [hideModalCookies, setHideModalCookies] = useState<boolean>(false);
    const isTabletOrMobile = useMediaQuery({ query: "(max-width: 510.98px)" });

    const acceptCookies = () => {
        localStorage.setItem("cookiesAccepted", "cookiesAccepted");
        setHideModalCookies(true);
    };
    return (
        <div className={`cookiePolicy-mainContainer ${hideModalCookies ? "cookiePolicy--hide" : ""}`}>
            <div className="cookiesPolicy-mainContent">
                <div className="cookiePolicy-mainText">
                    {t("components.cookiePolicy.text")}
                    <span
                        className="cookiePolicy__openModal"
                        onClick={() => navigate("#cookie-policy")}
                    >
                        {t("components.cookiePolicy.link")}
                    </span>
                </div>
                <div className="cookiePolicy_btnsContainer">
                    {!isTabletOrMobile && (
                        <div
                            className="cookiePolicy__btn"
                            onClick={() => acceptCookies()}
                        >
                            {t("components.cookiePolicy.accept")}
                        </div>
                    )}
                    <div
                        onClick={() => acceptCookies()}
                        className="popup__close--blue"
                    />
                </div>
            </div>
            {isTabletOrMobile && (
                <div
                    className="cookiePolicy__btn"
                    onClick={() => acceptCookies()}
                >
                    {t("components.cookiePolicy.accept")}
                </div>
            )}
        </div>
    );
};

export default CookiePolicy;
